import type { PropsWithChildren } from "react"
import s from "./styles.module.scss"

export const JourneyCardBlock = ({ children }: PropsWithChildren) => (
  <div className={s.journeyBlock}>
    <div>{children}</div>
  </div>
)
